import React from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";

class ChiTietCongViec extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      dataSearch: {
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
      },
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  renderTableRows() {
    let List = [{ status: 0 }, { status: 1 }];
    return List.map((item, index) => (
      <tr className="active">
        <td>1</td>
        <td>
          15/9/2018
          <br />
          15/10/2018
        </td>
        <td className="">Nguyễn thị thu Hằng</td>
        <td className="">
          {item.status === 0 && "Không hoàn thành"}
          {item.status === 1 && "Hoàn thành"}
        </td>
        <td className="text-left">Đi nhiều lần không gặp</td>
        <td className="text-left">Làm tốt</td>
      </tr>
    ));
  }
  render() {
    let props = this.props;
    let { dataSearch } = this.state;
    var TotalQuantity = 15;
    return (
      <Modal
        {...props}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-pencil-circle"></i>
            </span>{" "}
            Gia hạn công việc
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse253"
                  className="card-header border-info"
                  href="#collapse253"
                  aria-expanded="true"
                  aria-controls="collapse253"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Chi tiết công việc</h3>
                  </a>
                </div>
                <div
                  id="collapse253"
                  aria-labelledby="headingCollapse253"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="form-body form-bordered-1">
                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Mã công việc
                          </label>
                          <div className="col-md-9">CV201011-001</div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Tên công việc
                          </label>
                          <div className="col-md-9">
                            Sang nhà Ánh Nhật đòi nợ
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Liên quan đến hợp đồng
                          </label>
                          <div className="col-md-9">LN201402-001</div>
                        </div>

                        <div className="form-group row ">
                          <label className="col-md-3 label-control">
                            Nội dung công việc
                          </label>
                          <div className="col-md-9">
                            Sang nhà Ánh Nhật đòi nợ. Nếu không đòi được thì
                            ngồi cắm cọc ở đấy
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Người giao việc
                          </label>
                          <div className="col-md-9">Nguyễn Ánh Nhật</div>
                        </div>

                        <div className="form-group row">
                          <label className="col-md-3 label-control">
                            Trạng thái
                          </label>
                          <div className="col-md-9">Đang thực hiện</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse25322"
                  className="card-header border-info"
                  href="#collapse25322"
                  aria-expanded="true"
                  aria-controls="collapse25322"
                >
                  <a
                    className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h3>Người nhận việc</h3>
                  </a>
                </div>
                <div
                  id="collapse25322"
                  aria-labelledby="headingCollapse25322"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="table-responsive table-2">
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th className="w-stt">STT</th>
                              <th className="w-stt">Thời gian</th>
                              <th className="w-15">Người nhận việc</th>
                              <th className="w-10">Đánh giá</th>
                              <th className="text-left">
                                Lý do không hoàn thành
                              </th>
                              <th className="text-left">Nhận xét</th>
                            </tr>
                          </thead>
                          <tbody>{this.renderTableRows()}</tbody>
                        </table>
                      </div>
                      <div
                        className={
                          "paniation-new paniation-new1 d-flex justify-content-center mt-1" +
                          (TotalQuantity === 0 ? "hidden" : "")
                        }
                      >
                        <nav aria-label="Page navigation">
                          <Pagination
                            activePage={dataSearch.pageIndex}
                            itemsCountPerPage={dataSearch.pageSize}
                            totalItemsCount={TotalQuantity}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                            activeClass="active"
                          />
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ChiTietCongViec;
